<template>
	<!-- 大盒子 -->
	<div class="MedicenCata" id="rightCont">
		<!-- 全局loading遮罩层 -->
		<div v-if="globalLoading" class="global-loading-mask">
			<div class="global-loading-content">
				<el-icon class="is-loading" style="font-size: 40px; color: #409EFF;">
					<el-icon-loading />
				</el-icon>
				<div class="loading-text">{{ loadingText }}</div>
			</div>
		</div>
		
		<!-- 主体内容 -->
		<div class="main" :class="{ 'loading-blur': globalLoading }">
			<div class="main-right">
				<!-- 顶部搜索区域 -->
				<div class="main-header">
					<div class="header-left">
						<i class="el-icon-byj header-icon"></i>
						<span class="header-title">药品调价</span>
					</div>
					<div class="header-right">
            <!-- 药库切换 -->
            <div class="filter-item" style="margin-left: 12px;">
              <span class="filter-label">药库/药房：</span>
              <el-select 
                v-model="currentDepotId" 
                placeholder="请选择" 
                size="small" 
                style="width: 120px"
                @change="handleDepotChange"
                :disabled="globalLoading"
              >
                <el-option 
                  v-for="depot in depotOptions" 
                  :key="depot.id" 
                  :label="depot.label" 
                  :value="depot.id"
                ></el-option>
              </el-select>
            </div>
						
						<!-- 状态筛选 -->
						<div class="filter-item">
							<span class="filter-label">状态：</span>
							<el-dropdown @command="handleCommand" trigger="click" :disabled="globalLoading">
								<span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="a">可用</el-dropdown-item>
									<el-dropdown-item command="b">禁用</el-dropdown-item>
									<el-dropdown-item command="c" divided>全部</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						
						<!-- 关键字搜索 -->
						<div class="filter-item">
							<span class="filter-label">关键字：</span>
							<el-input 
                size="small" 
                placeholder="编码、名称、拼音简码" 
                suffix-icon="el-icon-Ssearch" 
								v-model="searchValue" 
                @input="handleSearchChange" 
                clearable 
                style="width: 200px;"
                :disabled="globalLoading"
              >
              </el-input>
						</div>
						
						<!-- 操作按钮 -->
						<div class="filter-item">
							<el-button 
                v-for="(v, i) in headerBtn" 
                :key="i" 
                :type="v.type" 
                :loading="loading" 
								:icon="v.icon" 
                size="small" 
                @click="handleButtonClick(i)"
                :disabled="globalLoading"
              >
                {{ v.title }}
							</el-button>
						</div>
					</div>
				</div>
				
				<!-- 子组件区域 -->
				<div class="component-area">
          <component
            :is="currentComponent"
            ref="priceComponentRef"
            :loading="loading"
            :table-height="tableHeight"
            :search-keyword="searchValue"
            :status-filter="DropDownedName"
            :current-depot-id="currentDepotId"
            @current-change="handleCurrentTableChange"
            @detail-click="handleDetail"
            @size-change="handleSizeChange"
            @current-change-page="handleCurrentChange"
            @data-loading="handleDataLoading"
            @data-loaded="handleDataLoaded"
          ></component>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
	// 引入子组件
	import XykPrice from './xykPrice.vue';
	import XyfPrice from './xyfPrice.vue';
	import ZykPrice from './zykPrice.vue';
	import ZyfPrice from './zyfPrice.vue';
	
	export default {
		name: 'MedicinePriceAdjust',
		components: {
			XykPrice,
			XyfPrice,
			ZykPrice,
			ZyfPrice
		},
		data() {
			return {
				// 全局loading状态
				globalLoading: false,
				loadingText: '正在加载数据...',
				
				// 药库选项
				depotOptions: [
					{ id: 1, label: '西药库' },
					{ id: 3, label: '西药房' },
					{ id: 2, label: '中药库' },
					{ id: 4, label: '中药房' }
				],
				currentDepotId: 1,
				
				// 当前显示的子组件
				currentComponent: 'XykPrice',
				
				// 表格高度
				tableHeight: 500,
				// 搜索相关
				searchValue: '',
				DropDownedName: '可用',
				// 加载状态
				loading: false,
				// 搜索定时器
				searchTimer: null,
				// 顶部按钮
				headerBtn: [
					// { title: "刷新", type: "primary", icon: "el-icon-refresh" },
					// { title: "高级搜索", type: "", icon: "el-icon-Ssearch" },
				],
			};
		},
		watch: {
			// 监听药库ID变化，切换对应的子组件
			currentDepotId(newVal) {
				this.switchComponent(newVal);
			}
		},
		mounted() {
			this.calculateTableHeight();
			window.addEventListener('resize', this.calculateTableHeight);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calculateTableHeight);
		},
		methods: {
			// 根据药库ID切换子组件
			switchComponent(depotId) {
				const depotMap = {
					1: { component: 'XykPrice', name: '西药库' },
					3: { component: 'XyfPrice', name: '西药房' },
					2: { component: 'ZykPrice', name: '中药库' },
					4: { component: 'ZyfPrice', name: '中药房' }
				};
				
				const depotInfo = depotMap[depotId] || depotMap[1];
				this.loadingText = `正在切换到 ${depotInfo.name} 的调价数据...`;
				this.showGlobalLoading();
				
				// 切换组件
				this.currentComponent = depotInfo.component;
				
				// 等待组件渲染后触发数据加载
				this.$nextTick(() => {
					if (this.$refs.priceComponentRef && this.$refs.priceComponentRef.loadData) {
						this.$refs.priceComponentRef.loadData();
					} else {
						// 如果子组件没有loadData方法，延迟隐藏loading
						setTimeout(() => {
							this.hideGlobalLoading();
						}, 500);
					}
				});
			},
			
			// 显示全局loading
			showGlobalLoading() {
				this.globalLoading = true;
			},
			
			// 隐藏全局loading
			hideGlobalLoading() {
				this.globalLoading = false;
			},
			
			// 计算表格高度
			calculateTableHeight() {
				const windowHeight = window.innerHeight;
				const headerHeight = 80;
				const paginationHeight = 60;
				const margin = 40;
				this.tableHeight = windowHeight - headerHeight - paginationHeight - margin;
			},
			
			// 详情按钮点击
			handleDetail(row) {
				console.log('查看详情:', row);
				this.$message.info(`查看药品【${row.drugName || row.id}】的调价详情`);
			},
			
			// 搜索输入变化
			handleSearchChange(val) {
				clearTimeout(this.searchTimer);
				this.searchTimer = setTimeout(() => {
					this.triggerDataReload();
				}, 500);
			},
			
			// 触发子组件重新加载数据
			triggerDataReload() {
				if (this.$refs.priceComponentRef && this.$refs.priceComponentRef.loadData) {
					this.$refs.priceComponentRef.loadData();
				}
			},
			
			// 顶部按钮点击
			handleButtonClick(i) {
				switch (i) {
					case 0:
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.loading = false;
						}, 1000);
						break;
					case 1:
						this.$message.info('高级搜索功能开发中');
						break;
				}
			},
			
			// 状态筛选
			handleCommand(command) {
				switch (command) {
					case 'a':
						this.DropDownedName = '可用';
						break;
					case 'b':
						this.DropDownedName = '禁用';
						break;
					case 'c':
						this.DropDownedName = '全部';
						break;
				}
				this.triggerDataReload();
			},
			
			// 药库切换
			handleDepotChange(depotId) {
				console.log('切换药库:', depotId);
			},
			
			// 表格单选
			handleCurrentTableChange(val) {
				this.currentTable = val;
			},
			
			// 分页处理
			handleSizeChange(val) {
				this.triggerDataReload();
			},
			
			handleCurrentChange(val) {
				this.triggerDataReload();
			},
			
			// 处理子组件数据加载事件
			handleDataLoading() {
				this.loading = true;
			},
			
			// 处理子组件数据加载完成事件
			handleDataLoaded() {
				this.loading = false;
				this.hideGlobalLoading();
			}
		}
	}
</script>

<style lang="less" scoped>
	/* 样式保持不变，与原始代码相同 */
	.MedicenCata {
		height: 100%;
		width: 100%;
		background: #f5f7fa;
		padding: 20px;
		box-sizing: border-box;
		position: relative;
		
		.global-loading-mask {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: rgba(255, 255, 255, 0.8);
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 9999;
			
			.global-loading-content {
				text-align: center;
				background: #fff;
				padding: 40px;
				border-radius: 8px;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				
				.loading-text {
					margin-top: 20px;
					font-size: 16px;
					color: #606266;
					font-weight: 500;
				}
			}
		}
		
		.loading-blur {
			filter: blur(2px);
			pointer-events: none;
		}
		
		.main {
			height: 100%;
			background: #fff;
			border-radius: 8px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			overflow: hidden;
			transition: filter 0.3s ease;
			
			.main-right {
				height: 100%;
				display: flex;
				flex-direction: column;
				
				.main-header {
					display: flex;
					align-items: center;
					padding: 20px;
					border-bottom: 1px solid #e6e6e6;
					background: #fafbfc;
					
					.header-left {
						display: flex;
						align-items: center;
						
						.header-icon {
							border-radius: 50%;
							font-size: 20px;
							padding: 8px;
							background-color: #409EFF;
							color: #fff;
							margin-right: 12px;
						}
						
						.header-title {
							font-size: 16px;
							font-weight: 600;
							color: #303133;
						}
					}
					
					.header-right {
						display: flex;
						align-items: center;
						gap: 20px;
						
						.filter-item {
							display: flex;
							align-items: center;
							
							.filter-label {
								font-size: 14px;
								color: #606266;
								font-weight: 500;
								margin-right: 8px;
								white-space: nowrap;
							}
						}
					}
				}
				
				// 子组件区域
				.component-area {
					flex: 1;
					padding: 0 20px;
					overflow: hidden;
				}
			}
		}
	}
	// 全局样式调整
	/deep/ .el-table {
		font-size: 14px;
		
		.cell {
			line-height: 1.5;
			padding: 8px 12px;
		}
		
		th {
			background-color: #f5f7fa;
			color: #606266;
			font-weight: 600;
		}
		
		.el-button--mini {
			padding: 6px 12px;
		}
	}
	
	/deep/ .el-pagination {
		padding: 0;
	}
	
	/deep/ .el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
		font-size: 14px;
		
		&:hover {
			color: #66b1ff;
		}
	}
	
	// 响应式设计
	@media screen and (max-width: 1200px) {
		.MedicenCata {
			padding: 10px;
		}
		
		.main-header {
			flex-direction: column;
			align-items: flex-start !important;
			gap: 15px;
		}
		
		.header-right {
			flex-wrap: wrap;
		}
	}
	
	// 移动端优化
	@media screen and (max-width: 768px) {
		.MedicenCata {
			padding: 10px 5px;
		}
		
		.main {
			border-radius: 4px;
			
			.main-right {
				.main-header {
					padding: 15px 10px;
					flex-direction: column;
					align-items: stretch;
					gap: 12px;
					
					.header-left {
						justify-content: center;
						margin-bottom: 10px;
						
						.header-icon {
							font-size: 18px;
							padding: 6px;
							margin-right: 8px;
						}
						
						.header-title {
							font-size: 14px;
						}
					}
					
					.header-right {
						flex-direction: column;
						gap: 10px;
						width: 100%;
						
						.filter-item {
							width: 100%;
							justify-content: space-between;
							
							.filter-label {
								flex-shrink: 0;
								min-width: 60px;
							}
							
							.el-select,
							.el-input {
								flex: 1;
								min-width: 0;
							}
							
							.el-button {
								flex: 1;
								margin: 2px;
							}
						}
					}
				}
				
				.component-area {
					padding: 0 10px;
				}
			}
		}
	}
	
	// 超小屏幕优化
	@media screen and (max-width: 480px) {
		.MedicenCata {
			padding: 5px 0;
		}
		
		.main {
			border-radius: 0;
			
			.main-right {
				.main-header {
					padding: 10px 5px;
					
					.header-right {
						.filter-item {
							flex-direction: column;
							align-items: flex-start;
							gap: 5px;
							
							.filter-label {
								margin-bottom: 5px;
							}
						}
					}
				}
				
				.component-area {
					padding: 0 5px;
				}
			}
		}
	}
</style>